import request from '@/utils/request'

// 用户相关API
export * from './user'

// 公共API
export * from './common'

export default request